var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"div_rule"},[_c('img',{staticClass:"img_button",attrs:{"src":require("./imgs/button_rule.png")},on:{"click":_vm.goHome}})])])}
var staticRenderFns = []

export { render, staticRenderFns }